import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import moment from "moment-timezone";

import TableSortLabel from "@material-ui/core/TableSortLabel";
import TableContainer from "@material-ui/core/TableContainer";
import TablePagination from "@material-ui/core/TablePagination";
import { lighten, makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import Typography from "@material-ui/core/Typography";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import AddAlert from "@material-ui/icons/AddAlert";
import Checkbox from "@material-ui/core/Checkbox";
import TableRow from "@material-ui/core/TableRow";
import Toolbar from "@material-ui/core/Toolbar";
import Table from "@material-ui/core/Table";
import List from "@material-ui/icons/List";
import Grid from "@material-ui/core/Grid";
import Link from "@material-ui/core/Link";
import Box from "@material-ui/core/Box";
import Datetime from "react-datetime";

// core components
import { PAGINATION_DETAILS, PAGE_SIZES } from "../../common/constants";
import GridContainer from "components/Grid/GridContainer.js";
import Button from "components/CustomButtons/Button.js";
import CardHeader from "components/Card/CardHeader.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import GridItem from "components/Grid/GridItem.js";
import CardBody from "components/Card/CardBody.js";
import CardIcon from "components/Card/CardIcon.js";
import Loader from "components/Loader/Loader.js";
import Card from "components/Card/Card.js";

import {DELETE_ALERT_LOG_DATA_REQUEST, FETCH_ALERT_LOG_DATA_REQUEST, FETCH_ALERT_LOG_CSV_REQUEST} from "../../redux/device/actions";
import { FETCH_GUESTS_REQUEST } from "../../redux/guestMap/actions";
import { useComposeDispatcher } from "../../common/hooks";

import styles from "assets/jss/material-dashboard-pro-react/views/userStyle.js";
import NewFiltersBox from "views/FilterBox/NewFiltersBox";
const useStyles = makeStyles(styles);

const today = moment();
const disableFutureDt = (current) => current.isBefore(today);

const columns = [
  { id: "residentName", label: "Resident Name", minWidth: 130, sort: false },
  { id: "FriendlyNameA", label: "Friendly Name", minWidth: 130, sort: true },
  { id: "DevidAlerts", label: "Dev Id", minWidth: 130, sort: true },
  { id: "AlertType", label: "Alert Type", minWidth: 110, sort: true },
  { id: "Atext", label: "Alert Text", minWidth: 130, sort: true },
  { id: "TimestampA", label: "Alert Time", minWidth: 150, type: "date", sort: true},
];

export default function AlertLogs() {
  const classes = useStyles();

  const timerToClearSomewhere = useRef(null);

  const userDetails = JSON.parse(localStorage.getItem("user-details"));
  const loggedUserId = userDetails !== null ? userDetails.userId : "";
  const loggedUserRole = userDetails !== null ? userDetails.roles[0].role : "";

  const { device, guestMapData } = useSelector((state) => ({
    guestMapData: state.guestMap,
    device: state.device
  }));

  const [userInfo, setUserInfo] = useState({
    interval: "1 Hr",
    deviceDataModelId: "d36a4373-fbdc-44a3-8c96-4bb920041e40",
    friendlyName: "all",
    intervalStartTime: new Date(),
    supplierId: "cd5dc314-6e25-48a8-9d47-9e574b8fe3a0",
  });

  const [displayContainer, setDisplayContainer] = useState(false);
  
  const [guestSensors, setGuestSensors] = useState([]);

  const [toastStatus, setToastStatus] = useState(false);

  const [toastMessage, setToastMessage] = useState('');

  const [order, setOrder] = useState("maxValueProvidedOn");

  const [orderBy, setOrderBy] = useState("DESC");

  const [filterData, setFilterData] = useState({});

  const [exportToCsv, setExportToCsv] = useState({});
  const [exportToCsvTriggered, setExportToCsvTriggered] = useState(false);
  const [currentSearchResult, setCurrentSearchResult] = useState({});
  const [fetchDataTriggered, setFetchDataTriggered] = useState(false);

  const [rowsPerPage, setRowsPerPage] = useState(PAGINATION_DETAILS.pageSize);
  const [page, setPage] = useState(PAGINATION_DETAILS.pageNumber);
  const [selectedAll, setSelectedAll] = useState(false);
  const [checked, setChecked] = useState(false);
  const [selected, setSelected] = useState([]);

  const [deleteAlertLogData] = useComposeDispatcher(DELETE_ALERT_LOG_DATA_REQUEST);
  const [fetchAlertLogCsvData] = useComposeDispatcher(FETCH_ALERT_LOG_CSV_REQUEST);
  const [getAlertLogData] = useComposeDispatcher(FETCH_ALERT_LOG_DATA_REQUEST);
  const [getGuestsList] = useComposeDispatcher(FETCH_GUESTS_REQUEST);

  useEffect(() => {
    if (!device.loadingData) {
      if(exportToCsvTriggered) {
        setToastStatus(true);
        setExportToCsvTriggered(false)
        setToastMessage(device.success ? 'Alert log file downloaded successfully' : 'Error while downloading the alert log file')
      }
      
      if (fetchDataTriggered) {
        setToastStatus(true);
        setFetchDataTriggered(false)
        setToastMessage(device.success ? 'Alert log data fetched successfully' : 'Error while fetching the alert log data')
      }
    }
  }, [device.success]);

  useEffect(() => {
    if (loggedUserRole === "Patient") {
      setUserInfo({ ...userInfo, userId: loggedUserId });
    }

    if (loggedUserRole === "Guest") {
      getGuestsList({"deviceDataModelId": "299992ad-6d4a-4020-8501-8a004d45fffc"});
    }

    return () => {
      clearInterval(timerToClearSomewhere.current);
    };
  }, []);

  const getDeviceData = (newFilterData) => {
    let dataObj = {
      deviceDataModelId: "d36a4373-fbdc-44a3-8c96-4bb920041e40-as",
      devicePropertyCodes: ["FriendlyNameA", "DevidAlerts", "TimestampA"],
      deviceCriteria: [{ key: "FriendlyNameA", operator: "IsSet", value: null}],
    };
    if (newFilterData.friendlyName !== "all") {
      dataObj.deviceCriteria = [
        { key: "DevidAlerts", operator: "Equal", value: newFilterData.friendlyName }
      ];
    }

    if (loggedUserRole !== "Guest") {
      dataObj.ownerFilter = {users: newFilterData.user};
    }

    let identityDataFrame = []
    if (newFilterData.userId !== "all") {
      device.friendlyNameData.forEach(val => {
        if (val.macId != 'all') {
          let identityObj = {
            "deviceDataModelId": "d36a4373-fbdc-44a3-8c96-4bb920041e40-id",
            "ownerFilter": {"users": newFilterData.user},
            "devicePropertyCodes": ["FriendlyNameA", "DevidAlerts", "TimestampA"],
            "deviceCriteria": [{ "key": "Devid", "operator": "Equal", "value": newFilterData.friendlyName }]
          }
          identityDataFrame = [...identityDataFrame, identityObj];
        }
      })
    }

    setFilterData(dataObj);
    setSelectedAll(false);
    setPage(0);
    getAlertLogData({
      identityDataFrame,
      payload: {
        pageNumber: 0,
        pageSize: rowsPerPage,
        sortBy: order,
        sortOrder: orderBy,
      },
      data: dataObj,
    });
    setCurrentSearchResult({
      identityDataFrame,
      payload: {
        pageNumber: 0,
        pageSize: rowsPerPage,
        sortBy: order,
        sortOrder: orderBy,
      },
      data: dataObj,
    });
    setDisplayContainer(true);
    setChecked(false);
    setSelected([]);
  };

  const fetchDataWithDateRange = () => {
    if (!exportToCsv.startTime || !exportToCsv.endTime) {
      setToastStatus(true);
      setToastMessage('Please select both start and end dates');
      return;
    }

    if (moment(exportToCsv.startTime).isAfter(moment(exportToCsv.endTime))) {
      setToastStatus(true);
      setToastMessage('Start time must be less than end time');
      return;
    }

    // Create a copy of current search result with date range
    const fetchDataObj = {
      ...currentSearchResult,
      data: {
        ...currentSearchResult.data,
        rangeStartDateTime: moment(exportToCsv.startTime).format("YYYY-MM-DDTHH:mm:ss"),
        rangeEndDateTime: moment(exportToCsv.endTime).format("YYYY-MM-DDTHH:mm:ss")
      }
    };

    getAlertLogData(fetchDataObj);
    setFetchDataTriggered(true);
  };

  const createSortHandler = (property) => () => {
    const isAsc = order === `data.${property}.value` && orderBy === "ASC";
    setOrderBy(isAsc ? "DESC" : "ASC");
    setOrder(`data.${property}.value`);
    getAlertLogData({
      payload: {
        pageNumber: 0,
        pageSize: rowsPerPage,
        sortBy: `data.${property}.value`,
        sortOrder: isAsc ? "DESC" : "ASC",
      },
      data: filterData,
    });
    setPage(0);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setChecked(false);
    setSelected([]);
    getAlertLogData({
      payload: {
        pageNumber: newPage,
        pageSize: rowsPerPage,
        sortBy: order,
        sortOrder: orderBy,
      },
      data: filterData,
    });
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
    setChecked(false);
    setSelected([]);
    getAlertLogData({
      payload: {
        pageSize: +event.target.value, 
        sortOrder: order || orderBy,
        sortBy: order || orderBy,
        pageNumber: 0,
      },
      data: filterData,
    });
  };

  const onSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = device.errorLog.data.map((n) => n.deviceDataId);
      setSelected(newSelecteds);
      setChecked(event.target.checked);
      return;
    }
    setSelected([]);
    setChecked(false);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    newSelected.length === 0 && setChecked(false);
    setSelected(newSelected);
  };

  const isSelected = (deviceDataId) => selected.indexOf(deviceDataId) !== -1;

  /* In case Guest Update, Guest data also should update on Local */
  useEffect(() => {
    const tempGuestSensors = [];
    if (guestMapData.guestsList?.length) {
      const guestSensorsMapped = guestMapData?.guestsList[0]?.data?.Macaddreess?.value;
      if(guestSensorsMapped?.length) {
        if (guestSensorsMapped?.length > 1) {
          tempGuestSensors.push(device?.friendlyNameData[0]);
        }
        for (let j=0; j < device?.friendlyNameData?.length; j++) {
          if (guestSensorsMapped.indexOf(device?.friendlyNameData[j]?.macId) !== -1) {
            tempGuestSensors.push(device?.friendlyNameData[j]);
          }
        }
      }
      setGuestSensors(tempGuestSensors);
    }
    console.log(guestMapData.guestsList, tempGuestSensors, 'guestSensors');
  }, [guestMapData.guestsList, device?.friendlyNameData])

  const handleApply = (filterData) => {
    getDeviceData(filterData);
  };
  
  return (
    <>
      <NewFiltersBox onApply={handleApply} />
      <GridContainer>
        {displayContainer && (
          <GridItem xs={12}>
            <Card>
              <CardHeader color="danger" icon>
                <CardIcon color="danger">
                  <List />
                </CardIcon>
                {
                  device.errorLog.data.length > 0 && (
                    <Box style={{ float: "right" }}>
                      <GridContainer>
                        <GridItem xs={3} sm={3} md={3}>
                          <Box className={classes.cardIconTitle}>
                            <InputLabel style={{ fontSize: "12px" }}> Start Time </InputLabel>
                            <Datetime
                              isValidDate={disableFutureDt}
                              closeOnSelect={true}
                              value={exportToCsv.startTime}
                              onChange={(val) => {
                                let obj = {startTime: val};
                                setExportToCsv({ ...obj });
                              }}
                            />
                          </Box>
                        </GridItem>
                        <GridItem xs={3} sm={3} md={3}>
                          <Box className={classes.cardIconTitle}>
                            <InputLabel style={{ fontSize: "12px" }}> End Time </InputLabel>
                            <Datetime
                              isValidDate={
                                exportToCsv.startTime
                                  ? (current) => current.isAfter(exportToCsv.startTime) : disableFutureDt
                              }
                              closeOnSelect={true}
                              value={exportToCsv.endTime}
                              onChange={(val) => {
                                let obj = {endTime: val};
                                setExportToCsv({ ...exportToCsv, ...obj });
                              }}
                            />
                          </Box>
                        </GridItem>
                        <GridItem xs={6} sm={6} md={6}>
                          <Box className={classes.cardIconTitle} style={{ float: "right", display: "flex", gap: "10px" }}>
                            <Button
                              color="primary"
                              disabled={!exportToCsv.startTime || !exportToCsv.endTime || moment(exportToCsv.startTime).isAfter(moment(exportToCsv.endTime))}
                              onClick={fetchDataWithDateRange}
                            >
                              Fetch data
                            </Button>
                            <Button
                              color="primary"
                              disabled={!exportToCsv.startTime || !exportToCsv.endTime || moment(exportToCsv.startTime).isAfter(moment(exportToCsv.endTime))}
                              onClick={() => {
                                currentSearchResult.data.rangeEndDateTime = moment(exportToCsv.endTime).format("YYYY-MM-DDTHH:mm:ss")
                                currentSearchResult.data.rangeStartDateTime = moment(exportToCsv.startTime).format("YYYY-MM-DDTHH:mm:ss")
                                fetchAlertLogCsvData(currentSearchResult)
                                setExportToCsvTriggered(true)
                              }}
                            >
                              Export to CSV
                            </Button>
                          </Box>
                        </GridItem>
                      </GridContainer>
                    </Box>
                  )
                }
                <p className={classes.rowCardIconTitle}>Unread Alerts: {device.totalUnreadAlert} Total Alerts: {device.errorLog.count}</p>
              </CardHeader>
              <CardBody>
                {selected.length > 0 && (
                  <Toolbar
                    style={{
                      color: "#fd0808",
                      fontSize: "16px",
                      backgroundColor: lighten("#fd0808", 0.85),
                    }}
                  >
                    <Grid container>
                      <Grid
                        item
                        xs={10}
                        style={{
                          margin: "auto",
                        }}
                      >
                        <Typography
                          className={classes.title}
                          color="#fd0808"
                          variant="subtitle1"
                          component="div"
                        >
                          You have selected all{" "}
                          {selectedAll
                            ? device.errorLog.count
                            : selected.length}{" "}
                          records.{" "}
                          {device.errorLog.count > selected.length && (
                            <Link
                              color="#fd0808"
                              onClick={() => {
                                const currentStatus = selectedAll
                                  ? false
                                  : true;
                                setSelectedAll(currentStatus);
                              }}
                            >
                              {selectedAll ? `Unselect all` : `Select all`}{" "}
                              {device.errorLog.count} records
                            </Link>
                          )}
                        </Typography>
                      </Grid>
                      <Grid item xs={2}>
                        <Button
                          variant="outlined"
                          color="danger"
                          onClick={() => {
                            if (selectedAll) {
                              deleteAlertLogData({
                                deviceDataModelId:
                                  "d36a4373-fbdc-44a3-8c96-4bb920041e40-as",
                                userIds: [userInfo.userId],
                                filter: {
                                  payload: {
                                    pageNumber: page,
                                    pageSize: rowsPerPage,
                                    sortBy: "maxValueProvidedOn",
                                    sortOrder: "DESC",
                                  },
                                  data: filterData,
                                },
                              });
                            } else {
                              deleteAlertLogData({
                                deviceDataModelId:
                                  "d36a4373-fbdc-44a3-8c96-4bb920041e40-as",
                                deviceDataIds: selected,
                                filter: {
                                  payload: {
                                    pageNumber: page,
                                    pageSize: rowsPerPage,
                                    sortBy: "maxValueProvidedOn",
                                    sortOrder: "DESC",
                                  },
                                  data: filterData,
                                },
                              });
                            }
                            setSelected([]);
                          }}
                        >
                          Confirm Delete
                        </Button>
                      </Grid>
                    </Grid>
                  </Toolbar>
                )}
                <TableContainer className={classes.container}>
                  <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                      <TableRow>
                        <TableCell padding="checkbox">
                          <Checkbox
                            inputProps={{ "aria-label": "select all" }}
                            indeterminate={
                              selected.length > 0 &&
                              selected.length < device.errorLog.count
                            }
                            checked={checked}
                            onChange={onSelectAllClick}
                          />
                        </TableCell>
                        {columns.map((column) => (
                          <TableCell
                            key={column.id}
                            align={column.align}
                            style={{
                              maxWidth: column.minWidth,
                              minWidth: column.minWidth,
                            }}
                          >
                            {column.sort ? (
                              <TableSortLabel
                                style={{
                                  maxWidth: column.minWidth,
                                  minWidth: column.minWidth,
                                }}
                                active={orderBy === column.id}
                                direction={
                                  orderBy === column.id
                                    ? order.toLowerCase()
                                    : "asc"
                                }
                                onClick={createSortHandler(column.id)}
                              >
                                <Typography>{column.label}</Typography>
                              </TableSortLabel>
                            ) : (
                              <Typography>{column.label}</Typography>
                            )}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {device.errorLog.count === 0 && (
                        <TableRow>
                          <TableCell align="center" colSpan="7">
                            No records found
                          </TableCell>
                        </TableRow>
                      )}
                      {device.errorLog.data.map((row, index) => {
                        const labelId = `enhanced-table-checkbox-${index}`;
                        return (
                          <TableRow
                            hover
                            role="checkbox"
                            tabIndex={-1}
                            key={index + "" + row.userId}
                          >
                            {columns.map((column, cIndex) => {
                              let value = row[column.id];
                              if (column.type === "date") {
                                value = moment(row[column.id]).format("MMM Do YY, h:mm:ss a") + ` (${row?.abbrObj?.abbr})`; 
                              }
                              let errorStyle = "#000000";
                              if (column.id === "errorType") {
                                if (value.toLowerCase().trim() === "w") {
                                  errorStyle = "orange";
                                  value = "Warning";
                                } else if (value.toLowerCase().trim() === "e") {
                                  errorStyle = "red";
                                  value = "Error";
                                } else if (value.toLowerCase().trim() === "l") {
                                  value = "Log";
                                }
                              }
                              if (column.id === "errorText") {
                                if (
                                  row["errorType"].toLowerCase().trim() === "w"
                                ) {
                                  errorStyle = "orange";
                                } else if (
                                  row["errorType"].toLowerCase().trim() === "e"
                                ) {
                                  errorStyle = "red";
                                }
                              }
                              return (
                                <>
                                  {cIndex === 0 && (
                                    <TableCell padding="checkbox">
                                      <Checkbox
                                        onChange={(event) =>
                                          handleClick(event, row.deviceDataId)
                                        }
                                        checked={isSelected(row.deviceDataId)}
                                        inputProps={{
                                          "aria-labelledby": labelId,
                                        }}
                                      />
                                    </TableCell>
                                  )}
                                  <TableCell
                                    style={{
                                      color: errorStyle,
                                    }}
                                    key={column.id}
                                    align={column.align}
                                  >
                                    {column.id !== "action" &&
                                      column.format &&
                                      typeof value === "number"
                                      ? column.format(value)
                                      : value}
                                  </TableCell>
                                </>
                              );
                            })}
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
                <TablePagination
                  rowsPerPageOptions={PAGE_SIZES}
                  component="div"
                  count={device.errorLog.count}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onChangePage={handleChangePage}
                  onChangeRowsPerPage={handleChangeRowsPerPage}
                />
                {alert}
              </CardBody>
            </Card>
          </GridItem>
        )}
      </GridContainer>
      <Loader status={device.loading || device.loadingData} />
      <Snackbar
        place="tr"
        color="danger"
        icon={AddAlert}
        message={toastMessage}
        open={toastStatus}
        closeNotification={() => {
          setToastStatus(false)
          setToastMessage('')
        }}
      />
    </>
  );
}
